export default function sanitizeTagLabel(value) {
  return stripWhitespace(value);
}

function stripWhitespace(value) {
  return value.replace(/\s/g, '');
}
